import {defineCssVars} from '@chakra-ui/styled-system';

export const vars = defineCssVars(`bar-chart`, [`fill`]);
